import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Icon from 'vue-awesome/components/Icon';
import Multiselect from 'vue-multiselect'
import Notifications from 'vue-notification';
import { register } from 'ol/proj/proj4.js';
import proj4 from 'proj4';
import store from './store/index';
import 'bootstrap/dist/css/bootstrap.css';
import 'vue-awesome/icons';
import 'ol/ol.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';
import 'v-calendar/lib/v-calendar.min.css';
import App from './App';
import VCalendar from 'v-calendar';
import { Auth, AuthBBtn } from './auth/Auth.js';
import AuthMixin from './auth/AuthMixin.js';
import ContextInstance from './api/ContextInstance.js';


proj4.defs([
  [
    'EPSG:2180',
    '+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +units=m +no_defs'
  ],
  [
    'EPSG:2176',
    '+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +units=m +no_defs'
  ],
  [
    'EPSG:2177',
    '+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +units=m +no_defs'
  ],
  [
    'EPSG:2178',
    '+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +units=m +no_defs'
  ],
  [
    'EPSG:2179',
    '+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +units=m +no_defs'
  ],
  [
    'EPSG:3120',
    '+proj=sterea +lat_0=50.625 +lon_0=21.08333333333333 +k=0.9998 +x_0=4637000 +y_0=5467000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs'
  ],
  [
    'EPSG:2172',
    '+proj=sterea +lat_0=53.00194444444445 +lon_0=21.50277777777778 +k=0.9998 +x_0=4603000 +y_0=5806000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs'
  ],
  [
    'EPSG:2173',
    '+proj=sterea +lat_0=53.58333333333334 +lon_0=17.00833333333333 +k=0.9998 +x_0=3501000 +y_0=5999000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs'
  ],
  [
    'EPSG:2174',
    '+proj=sterea +lat_0=51.67083333333333 +lon_0=16.67222222222222 +k=0.9998 +x_0=3703000 +y_0=5627000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs'
  ],
  [
    'EPSG:2175',
    '+proj=tmerc +lat_0=0 +lon_0=18.95833333333333 +k=0.999983 +x_0=237000 +y_0=-4700000 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs'
  ],
  [
    'EPSG:3329',
    '+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=33.4,-146.6,-76.3,-0.359,-0.053,0.844,-0.84 +units=m +no_defs'
  ],
  [
    'EPSG:4326',
    '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs'
  ]
]);

register(proj4);

Vue.use(BootstrapVue, {
  BFormFile: {
    browseText: 'Wybierz plik',
  }
});
Vue.component('icon', Icon);
Vue.component('multiselect', Multiselect);
import 'element-ui/lib/theme-chalk/index.css';
import { DatePicker, TimeSelect, TimePicker } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/pl'
import locale from 'element-ui/lib/locale'
locale.use(lang);
Vue.component(DatePicker.name, DatePicker);
Vue.component(TimeSelect.name, TimeSelect);
Vue.component(TimePicker.name, TimePicker);
Vue.use(Notifications);
Vue.component('auth-b-btn', AuthBBtn);
Vue.component('auth', Auth);
Vue.mixin(AuthMixin);
Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  locale: 'pl-PL',
  datePickerShowDayPopover: false
});

Vue.prototype.$context = ContextInstance;

new Vue({
  el: '#app',
  store,
  data: {
    context: ContextInstance
  },
  render(h) {
    if (this.context.state.initialized) {
      return h(App);
    }
  },
  beforeCreate() {
    ContextInstance.init({});
  }
})


// ie / edge
if (!Array.prototype.flat) {
  Array.prototype.flat = function(depth) {
    var flattend = [];
    (function flat(array, depth) {
      for (let el of array) {
        if (Array.isArray(el) && depth > 0) {
          flat(el, depth - 1);
        } else {
          flattend.push(el);
        }
      }
    })(this, Math.floor(depth) || 1);
    return flattend;
  };
}